import useDeviceTheme from "@project/shared/src/useDeviceTheme"
import React from "react"
import {
  Description,
  DetailsText,
  MapCardStyle,
  SpecificDetails,
  Title,
} from "./type"

interface MapCardProps {
  country?: string
  description?: string
  location?: string
  location2?: string
  officeType?: string
  email?: string
}

const MapCard: React.FC<MapCardProps> = ({
  country,
  description,
  location,
  location2,
  officeType,
  email,
}) => {
  const isDarkTheme = useDeviceTheme()
  return (
    <MapCardStyle>
      <Title>{country.toUpperCase()}</Title>
      <Description>{description}</Description>
      <SpecificDetails>
        <img
          src={
            isDarkTheme
              ? "/assets/icons/office.svg"
              : "/assets/icons/office-light.svg"
          }
          width={"24px"}
          height={"24px"}
        />
        <DetailsText>{officeType}</DetailsText>
      </SpecificDetails>
      <SpecificDetails>
        <img
          src={
            isDarkTheme
              ? "/assets/icons/location.svg"
              : "/assets/icons/location-light.svg"
          }
          width={"24px"}
          height={"24px"}
        />
        <div className="location-div">
          <DetailsText>{location}</DetailsText>
          <DetailsText>{location2}</DetailsText>
        </div>
      </SpecificDetails>

      <SpecificDetails>
        <img
          src={
            isDarkTheme
              ? "/assets/icons/email.svg"
              : "/assets/icons/email-light.svg"
          }
          width={"24px"}
          height={"24px"}
        />
        <DetailsText>{email}</DetailsText>
      </SpecificDetails>
    </MapCardStyle>
  )
}

export { MapCard }
